import { withMcpApps } from 'site-modules/canvas/components/with-mcp-apps/with-mcp-apps';
import { ClientConfig } from 'client/configuration';
import { getAppKeyMap } from 'site-modules/canvas/utils/canvas-llm-client';
import { ChatCanvas } from './chat-canvas';

export const getMcpBaseUrl = ({ search658Recipe }) =>
  typeof window !== 'undefined'
    ? new URL(
        `${ClientConfig.get('codriver')?.mcpUrl}/llm/v1/mcp/${getAppKeyMap({ search658Recipe }).DEFAULT}`,
        window.location.origin
      ).toString()
    : '';

const getMcpAppsConfig = ({ search658Recipe }) => ({
  mcpBaseUrl: getMcpBaseUrl({ search658Recipe }),
  sandboxHtmlUrl: `https:${ClientConfig.get('unversionedUrl')}/codriver/mcp-app.html`,
});

export const McpAppsChatCanvas = withMcpApps(getMcpAppsConfig)(ChatCanvas);
